@if (form) {
    <div [formGroup]="form">
        <sirius-radio
            [name]="name"
            [label]="label"
            [options]="options"
            [formControlName]="name"
            [identifier]="identifier"></sirius-radio>
    </div>
}
